module.exports = __webpack_public_path__ + "99e16d972cb5970061418029168cf3de.svg";